var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('new-modal-wrapper', {
    ref: "vueUploadErrorModal",
    staticClass: "new-upload-error",
    attrs: {
      "widthModal": '80%',
      "maxWidthModal": 500,
      "modal-name": "uploadErrorModal",
      "show-close-icon": true,
      "click-to-close": true,
      "cta-primary-button": "uploadErrorChooseImage",
      "cta-primary-button-icon-name": "camera",
      "cta-primary-button-icon-type": "icon"
    },
    on: {
      "cta-action": function ctaAction($event) {
        return _vm.$refs.ugcImageUploadButton.onUploadClick();
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "new-modal-error-icon"
  }, [_vm._v("!")]), _c('h2', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.translations.uploadErrorHeader))]), _c('h5', {
    staticClass: "text-center subheader"
  }, [_vm._v("\n      " + _vm._s(_vm.translations.uploadErrorSubHeader) + "\n    ")]), _c('div', {
    staticClass: "center-list error-list"
  }, [_c('p', [_vm._v(_vm._s(_vm.translations.uploadErrorList2))]), _c('p', [_vm._v(_vm._s(_vm.translations.uploadErrorList3))]), _c('p', [_vm._v(_vm._s(_vm.translations.uploadErrorFileSize))])]), _c('p', {
    staticClass: "text-center error-link"
  }, [_c('a', {
    attrs: {
      "href": _vm.translations.uploadErrorLink,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.translations.uploadErrorLinkText))])]), _c('div', {
    staticClass: "CTA-wrapper row"
  }, [_c('div', {
    staticClass: "small-8 large-4 center-column columns"
  }, [_c('ugc-image-upload', {
    ref: "ugcImageUploadButton",
    staticClass: "hide",
    attrs: {
      "input-id": "error-modal-input",
      "input-label": _vm.translations.uploadErrorChooseImage,
      "disableButton": false
    },
    on: {
      "before-upload": function beforeUpload($event) {
        return _vm.$modal.hide('uploadErrorModal');
      }
    }
  })], 1)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }